import { useQuery, UseQueryOptions } from 'react-query';
import { BorrowerNda } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useCompanyNdaQuery(
	guid: string | undefined,
	options?: Omit<UseQueryOptions<BorrowerNda, unknown, BorrowerNda>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Deal.Nda(guid),
		() => AxiosUtils.getResponseData<BorrowerNda>(api.get(CerebroApiEndpoints.Deals.Nda(guid))),
		options
	);
}
